<template>
  <div id="surveySteps" class="d-none align-center d-md-flex">
    <template v-for="(page, index) in pages">
      <v-tooltip bottom :key="`${index}_stepBtn`">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            :elevation="index == innerValue ? '5' : '0'"
            :color="
              index == innerValue
                ? 'white font-weight-bold'
                : index <= innerValue
                ? hasQuestions(index)
                  ? 'secondary'
                  : 'grey lighten-3'
                : hasQuestions(index)
                ? 'grey lighten-2'
                : 'grey lighten-3'
            "
            @click="move(index)"
            :disabled="disabled(index) || stopped"
            :loading="loading && index === innerValue"
            class="step-ind"
            v-on="on"
            v-bind="attrs"
          >
            {{ index + 1 }}
          </v-btn>
        </template>
        <div>
          {{ page.displayName }}
          <small class="d-block" v-if="!hasQuestions(index) || stopped">
            (Disabled - does not qualify)
          </small>
        </div>
      </v-tooltip>

      <div
        :key="`${index}_stepPath`"
        class="flex-fill step-divider grey lighten-3"
        v-if="index != pages.length - 1"
        :class="{ disabled: disabled(index) || stopped }"
      >
        <div
          class="fill secondary pt-2"
          :style="`width: ${index >= innerValue ? '0' : '100%'}`"
        ></div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.v-btn.v-btn--disabled.step-ind {
  &:disabled {
    background-color: #efefef !important;
  }
}

.step-divider {
  margin: 0 -10px;

  &.disabled {
    background-color: #efefef !important;
  }

  .fill {
    transition: width 100ms ease-in-out;
  }
}
</style>

<script>
import { showQuestion, roadBlockQuestion } from "../constants/Survey";

export default {
  data: () => ({
    innerValue: 0,
  }),
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    validate: {
      type: Function,
    },
    formData: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    pageQuestionCounts() {
      let results = [];

      this.pages.forEach((x) => {
        let count = 0;
        x.questions?.forEach((y) => {
          if (showQuestion(y, this.formData)) count++;
        });

        results.push(count);
      });

      return results;
    },
    nextPageWithQuestions() {
      for (var i = this.innerValue + 1; i < this.pages.length; i++) {
        if (this.pageQuestionCounts[i] > 0) return i;
      }

      return null;
    },
    stopped() {
      let results = [];

      this.pages.forEach((x) => {
        let count = 0;
        x.questions?.forEach((y) => {
          if (roadBlockQuestion(y, this.formData)) count++;
        });

        results.push(count);
      });

      return results.reduce((x,y) => x + y, 0) > 0;
    },
  },
  watch: {
    value(val) {
      if (val != this.innerValue) this.innerValue = val;
    },
    innerValue(value) {
      if (value != this.value) this.$emit("input", value);
    },
  },
  methods: {
    disabled(index) {
      return (
        (this.innerValue != index &&
          this.nextPageWithQuestions &&
          index > this.nextPageWithQuestions) ||
        (this.innerValue != index && this.loading)
      );
    },
    hasQuestions(index) {
      let result = false;
      this.pages[index].questions.forEach((y) => {
        if (showQuestion(y, this.formData)) {
          result = true;
        }
      });

      return result;
    },

    move(index) {
      if (
        this.innerValue === index ||
        this.disabled(index) ||
        !this.hasQuestions(index)
      )
        return;

      if (index > 0) {
        if (this.validate()) this.innerValue = index;
      } else this.innerValue = index;
    },
  },
  mounted() {
    if (this.value) this.innerValue = this.value;
  },
};
</script>
